<template>
  <ul class="font-size-control list-group w-100">
    <li class="list-group-item text-left"
      v-for="(vocabulary, index) in data" :key="index">
      <div class="title w-100 pl-3" @click="play(vocabulary)">
        <i class="fa fa-volume-up"></i> <span v-html="vocabulary.name"></span>
      </div>
      <div class="w-100 pl-3">
        <span class="pron">{{ vocabulary.pronouncing }}</span><br />
        {{ vocabulary.partOfSpeech }} {{ vocabulary.name_i18N[0].value }}<br />

        <p v-for="(example, exampleIndex) in vocabulary.examples" :key="exampleIndex"
          v-bind:class="{ 'clickable': example.audio }"
          @click="play({ name: example.text, audio: example.audio })">
          <span v-if="example.audio"><i class="fa fa-volume-up"></i></span> <span v-html="example.text"></span><br />
          <span v-for="(lang, langIndex) in example.text_i18N" :key="langIndex">{{ lang.value }}</span>
        </p>
      </div>
    </li>
  </ul>
</template>

<script>
  export default {

    name: 'Vocabularies',

    props: {
      data: {
        type: Array,
        required: false,
        default: () => {
          return []
        }
      }
    },

    methods: {
      play (data) {
        this.$emit('audio', {
          name: data.name,
          url: data.audio
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/style/app.scss";

  .title {
    color: $vocab-color;
    font-size: 1.5em;
    cursor: pointer;

    .fa-volume-up {
      color: black;
      cursor: pointer;
    }
  }

  .list-group {
    .list-group-item {
      border: 0;
      border-bottom: 2px #ccc solid;

      &:last-child {
        border: 0;
      }
    }
  }

  .clickable {
    cursor: pointer;
  }

  .pron {
    color: $pron-color;
  }
</style>



// WEBPACK FOOTER //
// Vocabularies.vue?a895dea6